import React from 'react';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import {
  Box,
  Paper,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import * as partnerApi from '../../lib/api/partner';
import { useFormik, FormikProvider, FieldArray } from 'formik';
import PartnerUploadForm from '../../components/partnermng/PartnerUploadForm';
import Draggable from 'react-draggable';
import BootstrapDialog, {
  BootstrapDialogTitle,
} from '../../components/common/dialog/BootstrapDialog';
import * as yup from 'yup';

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-upload-dialog"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

//application/vnd.openxmlformats-officedocument.spreadsheetml.sheet:xlsx, application/vnd.ms-excel:xls
const SUPPORTED_FORMATS = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];
const PartnerUploadModalContainer = ({ title, open, handleClose }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const initialValues = {
    file: null,
  };
  const validationSchema = yup.object({
    file: yup
      .mixed()
      .required('파일을 선택하세요')
      .test('fileFormat', '지정된 XLSX파일만 가능합니다.', (value) => {
        //console.log(value);
        return value && SUPPORTED_FORMATS.includes(value.type);
      }),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);
      onSave(values);
      formik.resetForm();
      setSubmitting(false);
    },
  });

  const onSave = async (values) => {
    let formData = new FormData();
    formData.append('file', values.file);
    //console.log(formData, 'formData');

    try {
      const response = await partnerApi.uploadExl(formData);
      if (response.data) {
        enqueueSnackbar('업로드 되었습니다', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const onClose = () => {
    formik.resetForm();
    handleClose();
  };

  return (
    <BootstrapDialog
      open={open}
      onClose={onClose}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-upload-dialog"
      fullWidth={true}
      maxWidth="sm"
    >
      <BootstrapDialogTitle
        style={{ cursor: 'move' }}
        id="draggable-upload-dialog"
        onClose={onClose}
      >
        {title}
      </BootstrapDialogTitle>
      <DialogContent
        dividers
        sx={{
          height: 200,
          overflowY: 'auto',
        }}
      >
        <PartnerUploadForm formik={formik} />
      </DialogContent>
    </BootstrapDialog>
  );
};

export default PartnerUploadModalContainer;
